<template>
  <div class="d-flex justify-content-center">
    <b-button
      size="lg"
      pill
      variant="primary"
      @click.prevent="continueToPayment"
    >
      <div v-if="!showSpinner">
        <span>Continue To<strong> Payment</strong></span>
        <font-awesome-icon icon="arrow-right" size="xs" />
      </div>
      <div v-else>
        <b-spinner variant="light"></b-spinner><span>Connecting...</span>
      </div>
    </b-button>
  </div>
</template>

<script>
import { subscriptionApi } from "../../services/subscriptionApi";
import { customerApi } from "../../services/customerApi";
import { store } from "../../store/store";
import { mapGetters } from "vuex";
import { paymentFunctions } from "../../Commonjs/PaymentGateways/RazorPayGateway";

export default {
  name: "razor-pay-button",
  computed: {
    ...mapGetters("user", ["getPaymentDetails", "getUserRole"])
  },
  watch: {
    getPaymentDetails: function() {
      const paymentDetails = {
        gateway_id: this.gateway.gateway_id,
        razorpay_payment_id: this.getPaymentDetails.razorpay_payment_id,
        razorpay_order_id: this.getPaymentDetails.razorpay_order_id,
        razorpay_signature: this.getPaymentDetails.razorpay_signature,
        order_details: this.orderData
      };
      this.paymentValidation(paymentDetails);
    }
  },
  props: {
    courses: [],
    totalPrice: Number,
    gateway: Object,
    isCheckout: Boolean
  },
  data() {
    return {
      orderId: "",
      type: "course",
      showSpinner: false,
      order_items: [],
      orderData: {}
    };
  },
  methods: {
    // pay() {
    //   const options = {
    //     KEY: "rzp_test_xr5v065Upc2fV4", // 'rzp_live_Im4Cag6lCnir7B', // 'rzp_live_AzVnT7Wt6AR1MZ',
    //     amount: this.totalPrice * 100,
    //     // amount: 100,
    //     name: "Edfore",
    //     description: "Subscribe Course Payment",
    //     order_id: this.orderId,
    //     image:
    //       "https://banner2.kisspng.com/20180605/gqg/kisspng-lower-columbia-college-higher-education-school-sch-education-png-5b1706bc1306f0.112211061528235708078.jpg",
    //     callback_url: "",
    //     redirect: false,
    //     handler(response) {
    //       store.dispatch("user/setPaymentDetails", response);
    //     },
    //     // prefill: {
    //     //   name: `${this.getUserData.firstname}${this.getUserData.lastname}`,
    //     //   email: this.getUserData.email,
    //     //   contact: this.getUserData.phone,
    //     // },
    //     notes: {
    //       address: "Hello World"
    //     },
    //     theme: {
    //       color: "#FF4500"
    //     }
    //   };
    //   const rzp1 = new Razorpay(options);
    //   rzp1.open();
    // },
    paymentValidation(paymentDetails) {
      subscriptionApi
        .paymentValidation(paymentDetails)
        .then(res => {
          this.getCustomerDetails();
          store.dispatch("cart/addToCart", []);
        })
        .catch(e => {
          this.$bvToast.toast(`Payment Validation Failed ${e.body.message}`, {
            title: "Order",
            autoHideDelay: 500,
            appendToast: true
          });
          console.error("payment validation api fail", e);
        });
    },
    continueToPayment() {
      if (!this.gateway) {
        this.$emit("optionValidation");
      } else {
        this.showSpinner = true;
        this.orderData = {
          gateway_id: this.gateway.gateway_id,
          gateway_name: this.gateway.gateway_name,
          order_items: this.courses,
          price: parseInt(this.totalPrice, 10),
          role: this.getUserRole
        };
        subscriptionApi
          .orderCreation(this.orderData)
          .then(res => {
            this.showSpinner = false;
            this.orderId = res.bodyText;
            // this.pay();
            paymentFunctions.pay(this.totalPrice, this.orderId);
          })
          .catch(e => {
            this.showSpinner = false;
            this.$bvToast.toast(`Order Failed ${e.body.message}`, {
              title: "Order",
              autoHideDelay: 500,
              appendToast: true
            });
            console.error("order api fail", e);
          });
      }
    },
    getCustomerDetails() {
      customerApi
        .getSubscribedCourses(this.getUserRole)
        .then(res => {
          if (this.isCheckout) {
            this.$router.push({
              path: "student/dashboard",
              query: {
                role: this.getUserRole
              }
            });
          } else {
            if (this.courses[0].course_type === "liveCourse") {
              this.$router.push({
                path: "course_description",
                query: {
                  courseId: this.courses[0].course_id,
                  courseType: "liveCourse"
                }
              });
            } else {
              this.$router.push({
                path: "course_description",
                query: {
                  courseId: this.courses[0].course_id
                }
              });
            }
          }
          console.log("customer Api success", res);
        })
        .catch(e => {
          console.error("customer Api failed", e);
        });
    }
  }
};
</script>

<style scoped></style>
